import React from 'react';

import { Row, Col, Button } from 'antd';

import { ProductSize } from '../../../../../../api-client';
import { orderTotalBySizes } from '../../../../../../utils/data-format-enchanters/order-products-enchanter';

import './wide-form-footer.scss';

interface IWideFormFooter {
    disabled: boolean;
    orderLineId?: number;
    subTotal: ProductSize[];
    onDelete: (id: number) => void;
    onSubmit: () => void;
}

const WideFormFooter: React.FunctionComponent<IWideFormFooter> = ({ disabled, orderLineId, subTotal, onDelete, onSubmit }) => (
    <div className="wide-form-footer-container">
        <Row style={{ alignItems: 'center' }}>
            <Col span={8}>
                <Button
                    type="primary"
                    disabled={disabled}
                    style={{ marginRight: 10 }}
                    onClick={onSubmit}
                >
                    {!orderLineId ? 'Add to cart' : 'Update Product'}
                </Button>

                {orderLineId &&
                    <Button
                        type="primary"
                        disabled={disabled}
                        onClick={() => onDelete(orderLineId)}
                    >
                        {'Delete'}
                    </Button>
                }
            </Col>
            <Col span={16} style={{ textAlign: 'right' }}>
                <span className="wide-form-footer-subtotal">
                    {`Subtotal: ${orderTotalBySizes(subTotal).amountFormat}`}
                </span>
            </Col>
        </Row>
    </div>
);

export default WideFormFooter;